module.exports = __webpack_public_path__ + "assets/images/project/constituencies/yuhua-smc.jpg?v=c3be6414";